/* unplugin-vue-components disabled */import { render } from "./source-icon.vue?vue&type=template&id=2e79c734"
import script from "./source-icon.vue?vue&type=script&lang=js"
export * from "./source-icon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sources/source-icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e79c734"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e79c734', __exports__)) {
    api.reload('2e79c734', __exports__)
  }
  
  module.hot.accept("./source-icon.vue?vue&type=template&id=2e79c734", () => {
    api.rerender('2e79c734', render)
  })

}


export default __exports__